import { useEffect, useState } from 'react';
import { ClientProfileView } from '../../views';
import { LocalStorageService, ClientService, CatalogService } from '../../../services';
import { ModalUtil, SimpleLoading } from "../../pures";
import { useTranslation } from "react-i18next";

const ClientProfileAction = () => {
  const { t: trans } = useTranslation('clients-dashboard', { keyPrefix: 'companyDetailsScreen' });
  const { t } = useTranslation();
  const { t: tCommon, ready } = useTranslation('common');

  const url = process.env.REACT_APP_ETICKET_API;
  const localStorageService = new LocalStorageService();
  const clientService = new ClientService(url);
  const modalUtil = new ModalUtil();
  const token = JSON.parse(localStorage.getItem('token')).accessToken

  const [isEditing, setIsEditing] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [companyData, setCompanyData] = useState({});
  const [name, setName] = useState('');
  const [image, setImage] = useState(null);
  const [imageSrc, setImageSrc] = useState(null)
  // const [imagePath, setImagePath] = useState('')
  const [emailContact, setEmailContact] = useState('');
  const [telephoneNumber, setTelephoneNumber] = useState('');

  useEffect(() => {
    getClientData()
  }, [])

  // useEffect(() => {
  //     localStorageService.setLocalStorageItem("clientLogo", imagePath)
  // }, [imagePath])

  const getClientData = async () => {
    const { userMetaData: { userA3Cloud: { client } } } = await localStorageService.getLocalStorageItem("user");
    setCompanyData(client)
    setName(client.name)
    // setRfc(client.rfc)
    // setNiche(client.niche)
    // setOrganization(client.organization)
    setImage(client.image)
    setEmailContact(client.emailContact)
    setTelephoneNumber(client.telephoneNumber)
    setInitialLoading(false)
    // setCategory(client.category)
  }

  const onInputChange = ({ target }, setValue) => {
    setValue(target.value)
  }

  const toggleEditMode = () => {
    setIsEditing(!isEditing)
    setName(companyData.name)
    // setRfc(companyData.rfc)
    // setNiche(companyData.niche)
    // setOrganization(companyData.organization)
    setImage(companyData.image)
    setImageSrc(null)
    setEmailContact(companyData.emailContact)
    setTelephoneNumber(companyData.telephoneNumber)
  };

  const handleInputChange = async () => {
    try {
      modalUtil.showModal('loading', trans("loadingModal"), t("modal.pure.loading.title"))

      let clientProfileInformation = new FormData();
      clientProfileInformation.append("name", name)
      clientProfileInformation.append("image", image)
      clientProfileInformation.append("emailContact", emailContact)
      clientProfileInformation.append("telephoneNumber", telephoneNumber)

      const updatedClientProfileInformation = await clientService.updateClientProfileInformation(token, clientProfileInformation)
      if (updatedClientProfileInformation && updatedClientProfileInformation.data && Number(updatedClientProfileInformation.statusCode) === 200) {
        modalUtil.showModal('success', trans("updatedInfoSuccessModal"), t("modal.pure.title.success"), getClientData);
        setTimeout(() => {
          // setImagePath(updatedClientProfileInformation.data.image)
          window.location.reload();
        }, 1000)
      } else {
        modalUtil.showModal('error', trans("updatedInfoErrorModal"), t("modal.pure.title.error"))
      }
    } catch (error) {
      modalUtil.showModal('error', trans("updatedInfoErrorModal"), t("modal.pure.title.error"))
    }
  };

  const modalError = () => {
    modalUtil.showModal('error', trans("updatedImageErrorModal"), t("modal.pure.title.error"));
  }

  const modalSuccess = async () => {
    await modalUtil.showModal('success', trans("updatedImageSuccessModal"), t("modal.pure.title.success"));
  }

  const onStatusChange = async (event) => {
    if (event.affectedFiles[0].status === 0) modalError();
    if (event.affectedFiles[0].status === 4) modalSuccess();
  }

  const handleImageUpload = (file) => {
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setImageSrc(reader.result)
      }
      reader.readAsDataURL(file)
    } else {
      setImageSrc(null)
    }
  }

  return (
    <>
      {
        initialLoading ?
          <div className="loading">
            <SimpleLoading />
          </div> : < ClientProfileView
            trans={trans}
            isEditing={isEditing}
            initialLoading={initialLoading}
            handleInputChange={handleInputChange}
            onInputChange={onInputChange}
            toggleEditMode={toggleEditMode}
            onStatusChange={onStatusChange}
            handleImageUpload={handleImageUpload}

            name={name}
            setName={setName}
            image={image}
            setImage={setImage}
            imageSrc={imageSrc}
            emailContact={emailContact}
            setEmailContact={setEmailContact}
            telephoneNumber={telephoneNumber}
            setTelephoneNumber={setTelephoneNumber}
          />
      }
    </>
  )
};

export default ClientProfileAction